import packageJson from '../../package.json';

// 通用配置
export const COMMON_CONFIG = {
  VERSION: packageJson.version,
  APP_NAME: 'magic-web',
};
